import { render } from "./FaultManagementSearch.vue?vue&type=template&id=8c87234e"
import script from "./FaultManagementSearch.vue?vue&type=script&lang=js"
export * from "./FaultManagementSearch.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sjoshi6/git/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__